import React from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";

import BottomNav from "./components/BottomNav";
import Feed from "./pages/Feed";
import Profile from "./pages/Profile";
import DesignPage from "./pages/Design";
import PublicProfilePage from "./pages/PublicProfilePage";
import Privacy from "./pages/Privacy";
import RefundPolicyPage from "./pages/RefundPolicyPage";
import SellerTerms from "./pages/SellerTerms";
import ShopTest from "./pages/ShopTest";
import Terms from "./pages/Terms";
import { DEFAULT_LOCALE } from "./utils/locale";

function resolvePreferredLocale() {
  if (typeof window === "undefined") {
    return DEFAULT_LOCALE;
  }

  try {
    const saved = (window.localStorage.getItem("disparty_locale") || "").toLowerCase();
    if (saved === "ko" || saved === "vi") {
      return saved;
    }
  } catch (error) {
    // ignore storage errors
  }

  const languages = [
    ...(Array.isArray(window.navigator.languages) ? window.navigator.languages : []),
    window.navigator.language || "",
  ]
    .join(",")
    .toLowerCase();

  if (languages.includes("vi")) {
    return "vi";
  }

  return DEFAULT_LOCALE;
}

function RootRedirect() {
  const targetLocale = resolvePreferredLocale();
  return <Navigate to={`/${targetLocale}`} replace />;
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

function AppContent() {
  const location = useLocation();

  const showBottomNav =
    location.pathname === "/ko" ||
    location.pathname === "/vi" ||
    location.pathname === "/profile" ||
    location.pathname === "/design" ||
    location.pathname === "/ko/profile" ||
    location.pathname === "/vi/profile" ||
    location.pathname === "/ko/design" ||
    location.pathname === "/vi/design" ||
    location.pathname === "/ko/test";

  const isDesignPage =
    location.pathname === "/design" ||
    location.pathname === "/ko/design" ||
    location.pathname === "/vi/design";

  return (
    <>
      <main className={`min-h-screen ${isDesignPage ? "" : "bg-gray-950"} ${showBottomNav && !isDesignPage ? "pb-16" : ""}`}>
        <Routes>
          <Route path="/" element={<RootRedirect />} />

          <Route path="/ko" element={<Feed />} />
          <Route path="/vi" element={<Feed />} />
          <Route path="/ko/privacy" element={<Privacy />} />
          <Route path="/vi/privacy" element={<Privacy />} />
          <Route path="/ko/terms" element={<Terms />} />
          <Route path="/ko/seller-terms" element={<SellerTerms />} />
          <Route path="/ko/refund-policy" element={<RefundPolicyPage />} />
          <Route path="/ko/profile" element={<Profile />} />
          <Route path="/vi/profile" element={<Profile />} />
          <Route path="/ko/design" element={<DesignPage />} />
          <Route path="/vi/design" element={<DesignPage />} />
          <Route path="/ko/test" element={<ShopTest />} />
          <Route path="/vi/test" element={<Navigate to="/vi" replace />} />

          <Route path="/profile" element={<Profile />} />
          <Route path="/design" element={<DesignPage />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/seller-terms" element={<SellerTerms />} />
          <Route path="/refund-policy" element={<RefundPolicyPage />} />
          <Route path="/:locale/:uniqueId" element={<PublicProfilePage />} />
          <Route path="/:uniqueId" element={<PublicProfilePage />} />
          <Route path="*" element={<Navigate to={`/${DEFAULT_LOCALE}`} replace />} />
        </Routes>
      </main>

      {showBottomNav && <BottomNav />}
    </>
  );
}

export default App;
